import Footer from "components/ui/Footer";
import Header from "components/ui/Header";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export const WrapperLayout = ({ children }: Props) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};
